/**
 * Validation Studies — frontend behaviour.
 *
 * Blur-reveal entrance for the eyebrow, each study row and each brochure card.
 * Loaded as an ES module only on pages where this block renders.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-vstudies]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const targets = section.querySelectorAll('[data-vstudies-anim], [data-vstudies-card]');
		if (!targets.length) return;

		if (reduced) {
			targets.forEach((el) => { el.style.opacity = '1'; el.style.transform = 'none'; });
			return;
		}

		gsap.set(targets, { opacity: 0, y: 24, filter: 'blur(10px)' });

		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				io.unobserve(entry.target);
				gsap.to(entry.target, {
					opacity: 1, y: 0, filter: 'blur(0px)',
					duration: 0.8, ease: 'power3.out',
					clearProps: 'transform',
				});
			});
		}, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

		targets.forEach((el) => io.observe(el));
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
